import { getAuth, signOut } from 'firebase/auth';
const handleLogout = async () => {
  const auth = getAuth();
  try {
    await signOut(auth);
  } catch (error) {
    alert(error.message);
  }
};

export default handleLogout;
